import { useCallback, useRef } from 'react'
import { apiClient } from '@/services/apiClient'

/** SA-1381: at most one typing ping to the visitor's widget per this long. */
export const TEAM_TYPING_PING_MS = 3000

/**
 * Returns a handler for the reply box's onChange: on a widget chat it tells
 * the visitor a team member is typing, at most once per TEAM_TYPING_PING_MS.
 * A failed ping is ignored.
 */
export function useTeamTypingPing(
  conversationId: string | undefined,
  channel: string | undefined,
): () => void {
  const lastRef = useRef<{ id: string; at: number } | null>(null)
  return useCallback(() => {
    if (channel !== 'widget' || !conversationId) return
    const now = Date.now()
    const last = lastRef.current
    if (last && last.id === conversationId && now - last.at < TEAM_TYPING_PING_MS) return
    lastRef.current = { id: conversationId, at: now }
    void Promise.resolve(
      apiClient.fetch(`/api/inbox/conversations/${conversationId}/typing`, { method: 'POST' }),
    ).catch(() => {})
  }, [conversationId, channel])
}
